iScreenWizard.factory('WizardContent', function ($q, Ajax) {

    const E_LEARNING = 1;
    const KLANTERVARINGEN = 2;
    const NIEUWSBRIEVEN = 3;

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('wizardcontent').then(function (response) {
                var wizardcontents = response.data;
                resolve(wizardcontents);
            }, reject);
        });
    };

    data.eLearning = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('wizardcontent/'+E_LEARNING).then(function (response) {
                var wizardcontent = response.data;
                resolve(wizardcontent);
            }, reject);
        });
    };

    data.klantervaringen = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('wizardcontent/'+KLANTERVARINGEN).then(function (response) {
                var wizardcontent = response.data;
                resolve(wizardcontent);
            }, reject);
        });
    };

    data.nieuwsbrieven = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('wizardcontent/'+NIEUWSBRIEVEN).then(function (response) {
                var wizardcontent = response.data;
                resolve(wizardcontent);
            }, reject);
        });
    };

    return data;
});